import URLS from "./UrlConfig";
import futch from "./Api";

export async function CoreServiceApi0(token, server, entity, action, jdata) {
  let url = URLS.baseURL[server] + entity + "/" + action;
  // debugger;
  // let raw = JSON.stringify({
  //   objectId: entity,
  //   actionType: action,
  //   jsonValues: jdata,
  // });
  let raw = JSON.stringify(jdata);

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(url, requestOptions);

  return Response;
}
export async function CoreServiceApi(token, endPoint, jdata) {
  let url = URLS.baseURL[0] + endPoint;
  // debugger;
  // let raw = JSON.stringify({
  //   objectId: entity,
  //   actionType: action,
  //   jsonValues: jdata,
  // });
  let raw = JSON.stringify(jdata);

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(url, requestOptions);

  return Response;
}
const exportedObject = {
  CoreServiceApi,
};
export default exportedObject;
